export enum LayoutThreeDateRangeOptionId {
  THIS_WEEK = 'this_week',
  THIS_MONTH = 'this_month',
  LAST_MONTH = 'last_month',
  THIS_YEAR = 'this_year',
  ALL_TIME = 'all_time',
  CUSTOM = 'custom_range',
}

export const LAYOUT_NUMBER = 3;

export enum PillId {
  CONSENTED_PARTICIPANTS = 'consented_participants',
  CAMPAIGN_TRACKING = 'campaign_tracking',
}
